import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
  Option,
} from "@p0security/shared/install/types";
import { mapValues } from "lodash-es";

import { PagerdutyRegions } from "./regions.ts";

const allSecretManagers = newSecretManagerElement({
  owner: "PagerDuty account",
  connector: "PagerDuty",
});

const secretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
});

// The connector's IAM condition matches the id up to the next `_` in each GCP
// secret name, where `/` becomes `_` and `.` becomes `-`.
const ITEM_ID_PATTERN = /^[A-Za-z0-9-]+$/;

// The subdomain goes into a space-separated scope list.
const SUBDOMAIN_PATTERN = /^[a-z0-9-]+$/;

export const PagerdutyAiComponents = InstallSpec({
  credential: ItemComponent({
    label: "Credential provisioning",
    description: "Allow P0 to grant machines access to PagerDuty",
    type: "string",
    maturity: "beta",
    validator: async (_context: unknown, id: string) =>
      ITEM_ID_PATTERN.test(id)
        ? undefined
        : "Use only letters, digits and hyphens",
    schema: {
      region: Element({
        label: "PagerDuty region",
        description: "The PagerDuty service region that hosts this account",
        type: "select",
        default: "us",
        step: "new",
        options: mapValues(PagerdutyRegions, ({ label }) =>
          Option({ label, maturity: "ga", schema: {} })
        ),
      }),
      subdomain: Element({
        label: "Account subdomain",
        description:
          "The subdomain of this account, as shown in its URL (e.g. acme in acme.pagerduty.com or acme.eu.pagerduty.com)",
        type: "string",
        step: "new",
        validator: async (_context: unknown, subdomain: string) =>
          SUBDOMAIN_PATTERN.test(subdomain)
            ? undefined
            : "Use only lowercase letters, digits and hyphens",
      }),
      secretManager,
      clientId: Element({
        label: "Client ID",
        description:
          "Client ID of the PagerDuty Scoped OAuth app that P0 requests tokens with. The app's scopes limit which scopes can be requested.",
        type: "string",
      }),
    },
  }),
});
